"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CountryTestTracker = void 0;
class CountryTestTracker {
    /**
     * Fire a tracking event that contains the parameters that were passed along.
     *
     * @param {string} action
     * @param {string | undefined} label
     * @param {string | undefined} property
     * @param {number | undefined} value
     * @returns void
     */
    static fireTracking(action, label, property, value) {
        if (!window.snowplow) {
            console.warn('CountryTestTracker.fireTracking: snowplow not available on window.');
            return;
        }
        window.snowplow('trackStructEvent', {
            category: 'country_test',
            action: action,
            label: label,
            property: property,
            value: value
        });
    }
}
exports.CountryTestTracker = CountryTestTracker;
